/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsExecuteGipAltReportMutationRequest, AuditReportsExecuteGipAltReportMutationResponse, AuditReportsExecuteGipAltReportQueryParams, AuditReportsExecuteGipAltReport400, AuditReportsExecuteGipAltReport401, AuditReportsExecuteGipAltReport403, AuditReportsExecuteGipAltReport500 } from "../models/AuditReportsExecuteGipAltReport";

export function getAuditReportsExecuteGipAltReportUrl() {
  const res = { method: 'POST', url: `/audit-reports/v1/reports/gip-alt/results` as const }
  return res
}

/**
 * @summary Generate report results
 * {@link /audit-reports/v1/reports/gip-alt/results}
 */
export async function auditReportsExecuteGipAltReport(data: AuditReportsExecuteGipAltReportMutationRequest, params?: AuditReportsExecuteGipAltReportQueryParams, config: Partial<RequestConfig<AuditReportsExecuteGipAltReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsExecuteGipAltReportMutationResponse, ResponseErrorConfig<AuditReportsExecuteGipAltReport400 | AuditReportsExecuteGipAltReport401 | AuditReportsExecuteGipAltReport403 | AuditReportsExecuteGipAltReport500>, AuditReportsExecuteGipAltReportMutationRequest>({ method : "POST", url : getAuditReportsExecuteGipAltReportUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}